import { AxiosResponse } from "axios";
import { client } from "../shared/services/client";
import { LookupData } from "../Models/LoookupData";
import * as tblConsts from "../shared/util/tableConstant";
import { AgencyDto } from "../Models/AgencyDto";
import { promises } from "dns";
import * as constant from '../shared/util/constant';


class LookupService {
    static fetchClaimStatusList = async (): Promise<LookupData[]> => {
        return await LookupService.getLookupData(tblConsts.CLAIM_STATUS_TABLE_ID);
    }

    static fetchLossTypeList = async (): Promise<LookupData[]> => {
        return await LookupService.getLookupData(tblConsts.LOSS_TYPE_TABLE_ID);
    }

    static fetchTaskPriorityList = async (): Promise<LookupData[]> => {
        return await LookupService.getLookupData(tblConsts.TASK_PRIORITY_TABLE_ID);
    }

    static fetchTaskStatusList = async (): Promise<LookupData[]> => {
        return await LookupService.getLookupData(tblConsts.TASK_STATUS_TABLE_ID);
    }

    static fetchTaskTypeList = async (): Promise<LookupData[]> => {
        return await LookupService.getLookupData(tblConsts.TASK_TYPE_TABLE_ID);
    }

    static fetchMaritalStatuses = async (): Promise<LookupData[]> => {
        return await LookupService.getLookupData(tblConsts.MARITAL_STATUS_TABLE_ID);
    }

    static fetchIndustries = async (): Promise<LookupData[]> => {
        return await LookupService.getLookupData(tblConsts.INDUSTRIES_TABLE_ID);
    }

    static fetchOccupancies = async (): Promise<LookupData[]> => {
        return await LookupService.getLookupData(tblConsts.OCCUPANCIES_TABLE_ID);
    }

    static fetchRelationships = async (): Promise<LookupData[]> => {
        return await LookupService.getLookupData(tblConsts.RELATIONSHIP_TABLE_ID);
    }

    static fetchState = async (): Promise<LookupData[]> => {
        return await LookupService.getLookupData(tblConsts.STATE_TABLE_ID);
    }
    static fetchCountries = async (): Promise<LookupData[]> => {
        return await LookupService.getLookupData(tblConsts.COUNTRY_TABLE_ID);
    }
    static fetchUSStates = async (): Promise<LookupData[]> => {
        return await LookupService.getLookupData(tblConsts.US_STATE_TABLE_ID);
    }
    static fetchCanadaStates = async (): Promise<LookupData[]> => {
        return await LookupService.getLookupData(tblConsts.CANADA_STATE_TABLE_ID);
    }

    static fetchGenderState = async (): Promise<LookupData[]> => {
        return await LookupService.getLookupData(tblConsts.GENDER_STATUS_TABLE_ID);
    }
    static fetchTransactionTypes = async (): Promise<LookupData[]> => {
        return await LookupService.getLookupData(tblConsts.TRANSACTION_TYPE_TABLE_ID);
    }
    static fetchIndividualizedState = async (): Promise<LookupData[]> => {
        return await LookupService.getLookupData(tblConsts.INDIVIDUALIZED_TABLE_ID);
    }
    static fetchPolicyTermStatus = async (): Promise<LookupData[]> => {
        return await LookupService.getLookupData(tblConsts.POLICY_TERM_STATUS_TABLE_ID);
    }
    static fetchPolicyType = async (): Promise<LookupData[]> => {
        return await LookupService.getLookupData(tblConsts.POLICY_TYPE_TABLE_ID);
    }
    static fetchPolicBusinessType = async (): Promise<LookupData[]> => {
        return await LookupService.getLookupData(tblConsts.POLICY_BUSINESS_TYPE_TABLE_ID);
    }
    static fetchPolicyPaymentPlan = async (): Promise<LookupData[]> => {
        return await LookupService.getLookupData(tblConsts.POLICY_PAYMENT_PLAN_TABLE_ID);
    }
    static fetchAttachType = async (): Promise<LookupData[]> => {
        return await LookupService.getLookupData(tblConsts.ATTACH_TYPE_TABLE_ID);
    }
    static fetchOccupancyType= async (): Promise<LookupData[]> => {
        return await LookupService.getLookupData(tblConsts.OCCUPANCY_TYPE);
    }
    static fetchResidenceType = async (): Promise<LookupData[]> => {
        return await LookupService.getLookupData(tblConsts.RESIDENCE_TYPE);
    }
    static fetchConstructionType = async (): Promise<LookupData[]> => {
        return await LookupService.getLookupData(tblConsts.CONSTRUCTION_TYPE);
    }
    static fetchRoofMaterialType = async (): Promise<LookupData[]> => {
        return await LookupService.getLookupData(tblConsts.ROOF_MATERIAL_TYPE);
    }
    static fetchHeatType = async (): Promise<LookupData[]> => {
        return await LookupService.getLookupData(tblConsts.HEAT_TYPE);
    }
    static fetchSprinklerType = async (): Promise<LookupData[]> => {
        return await LookupService.getLookupData(tblConsts.SPRINKLER_TYPE);
    }
    static fetchDwellingConditionType = async (): Promise<LookupData[]> => {
        return await LookupService.getLookupData(tblConsts.DWELLING_CONDITION_TYPE);
    }
    static fetchStormShutterType = async (): Promise<LookupData[]> => {
        return await LookupService.getLookupData(tblConsts.STORM_SHUTTER_TYPE);
    }
    static fetchDwellingLocType = async (): Promise<LookupData[]> => {
        return await LookupService.getLookupData(tblConsts.DWELLING_LOC_TYPE);
    }
    static fetchSecondaryHeatType = async (): Promise<LookupData[]> => {
        return await LookupService.getLookupData(tblConsts.SECONDARY_HEAT_TYPE);
    }
    static fetchFoundationType = async (): Promise<LookupData[]> => {
        return await LookupService.getLookupData(tblConsts.FOUNDATION_TYPE);
    }

    

    // static fetchAgencies = async () : Promise<AgencyDto[]> => 
    // {
    //     client.setBaseURLForService("admin");
    //     const config ={};
    //     const res: AxiosResponse<LookupData[]> =  await client.get(`/api/Agencies`, config);
    //     return res.data;
    // }

    static fetchAgencies = async (): Promise<LookupData[]> => {
        return await LookupService.getLookupData(tblConsts.AGENCY_TABLE_ID);
    }

    static getLookupData = async (tableId: string): Promise<LookupData[]> => {
        client.setBaseURLForService("admin")
        const config = {}
        const res: AxiosResponse<LookupData[]> = await client.get(`/api/LookupDetail/GetAllLookupDetails?tableId=${tableId}`, config);
        return res.data;
    }

    static fetchRedirectReason = async (): Promise<LookupData[]> => {
        return await LookupService.getLookupData(tblConsts.REDIRECT_REASON_TABLE_ID);
    }

    static fetchSourceType = async (): Promise<LookupData[]> => {
        return await LookupService.getLookupData(tblConsts.SOURCE_TYPE_TABLE_ID);
    }

    static fetchSourceTypeId = async (sourceTypeId:string): Promise<LookupData[]> => {
        const result: LookupData[] = [{
            lookupCode: constant.SourceTypeID_lookupCode[sourceTypeId],
            lookupValue: '',
            id: sourceTypeId,
            inactive: false,
            tableId: ''
        }];
        return result;
    }

    static fetchDeductibleTypes = async (): Promise<LookupData[]> => {
        return await LookupService.getLookupData(tblConsts.DEDUCTIBLE_TYPE_TABLE_ID);
    }

    static fetchHowBilledTypes = async (): Promise<LookupData[]> => {
        return await LookupService.getLookupData(tblConsts.HOWBILLED_TABLE_ID);
    }
    
    static fetchLineofBusiness = async (): Promise<LookupData[]> => {
        return await LookupService.getLookupData(tblConsts.LINE_OF_BUSINESS);
    }

     static fetchTransactionType = async (): Promise<LookupData[]> => {
        return await LookupService.getLookupData(tblConsts.TRANSACTION_TYPE);
    }

     static fetchCancellationReason = async (): Promise<LookupData[]> => {
        return await LookupService.getLookupData(tblConsts.CANCELLATION_REASON);
    }
    static fetchLOBApplications = async (): Promise<LookupData[]> => {
        return await LookupService.getLookupData(tblConsts.LOB_APPLICATION);
    }

    static fetchCompanyType = async (): Promise<LookupData[]> => {
        return await LookupService.getLookupData(tblConsts.COMPANY_TYPE);
    }

    static fetchCompanyStatus = async (): Promise<LookupData[]> => {
        return await LookupService.getLookupData(tblConsts.COMPANY_STATUS);
    }

    static fetchFormTypes = async (): Promise<LookupData[]> => {
        return await LookupService.getLookupData(tblConsts.FORM_TYPE);
    }

    static fetchBasementType = async (): Promise<LookupData[]> => {
        return await LookupService.getLookupData(tblConsts.Basement_Type);
    }

    static fetchNumberOfFloorsType = async (): Promise<LookupData[]> => {
        return await LookupService.getLookupData(tblConsts.NUMBER_OF_FLOORS_TYPE);
    }

    static fetchContentLocationType = async (): Promise<LookupData[]> => {
        return await LookupService.getLookupData(tblConsts.CONTENT_LOCATION_TYPE);
    }

    static fetchRatingType = async (): Promise<LookupData[]> => {
        return await LookupService.getLookupData(tblConsts.RATING_TYPE);
    }

    static fetchNearestShoreType = async (): Promise<LookupData[]> => {
        return await LookupService.getLookupData(tblConsts.NEAREST_SHORE_TYPE);
    }

    static fetchElevatedFoundationType = async (): Promise<LookupData[]> => {
        return await LookupService.getLookupData(tblConsts.ELEVATED_FOUNDATION_TYPE);
    }

    static fetchElevatedMaterialType = async (): Promise<LookupData[]> => {
        return await LookupService.getLookupData(tblConsts.ELEVATED_MATERIAL_TYPE);
    }

    static fetchEnclosedForOtherPurposeType = async (): Promise<LookupData[]> => {
        return await LookupService.getLookupData(tblConsts.ENCLOSED_FOR_OTHER_PURPOSE_TYPE);
    }

    static fetchFloodOccupancyType = async (): Promise<LookupData[]> => {
        return await LookupService.getLookupData(tblConsts.FLOOD_OCCUPANCY);
    }

    static fetchProtectionDeviceType = async (): Promise<LookupData[]> => {
        return await LookupService.getLookupData(tblConsts.PROTECTION_DEVICE_TYPE);
    }

    static fetchInterestType = async (): Promise<LookupData[]> => {
        return await LookupService.getLookupData(tblConsts.INTEREST_TYPE_TABLE_ID);
    }

    static fetchAdditionalInterestedParty = async (): Promise<LookupData[]> => {
        return await LookupService.getLookupData(tblConsts.ADDITIONAL_INTERESTED_PARTY_TABLE_ID);
    }
}

export default LookupService;